// Polyfill Promise for IE
//
window.Promise || (function() {
    var scr = document.createElement('script')
    scr.src = 'https://cdn.jsdelivr.net/npm/es6-promise@4/dist/es6-promise.auto.min.js'
    document.head.appendChild(scr)
})()
//
// End Polyfill


// Collection Grid Fix
//
var bc_BCSfFilterCallback = BCSfFilterCallback;
BCSfFilterCallback  = function(res) {
  var promises = []
  var currency = bcSfFilterConfig.general.current_currency.toLowerCase();
  for (var i = 0; i < res.products.length; i++) {
    promises.push(new Promise(function(resolve, reject) {
	  getProduct(res.products[i].handle, function(i, product) {
        if (typeof product.availableVariants === 'object') {
          res.products[i].variants = res.products[i].variants.map(function(variant) {
				variant.price = product.availableVariants[variant.id];
                variant['price_' + currency] =  product.availableVariants[variant.id];
                return variant;
          });
        }
        res.products[i].compare_at_price_min = product.compare_at_price_min / 100
        res.products[i].price_min = product.price_min / 100
        res.products[i].price_max = product.price_max / 100
        res.products[i]['compare_at_price_min_' + currency] = product.compare_at_price_min / 100
        res.products[i]['price_min_' + currency] = product.price_min / 100
        res.products[i]['price_max_' + currency] = product.price_max / 100
        return resolve()
      }.bind(this, i))
    }))
  }
  Promise.all(promises).then(function() {
    var final_products = []
    var prod
    for (var i in res.products) {
        prod = res.products[i]
        if (typeof prod === 'object') {
            final_products.push(prod)
        }
    }
    res.products = final_products
    bc_BCSfFilterCallback(res);
  })
}
//
// End Collection Grid Fix



// Start Search Fix
//
var bc_BCSfSuggestionCallback = BCSfSuggestionCallback;
BCSfSuggestionCallback  = function(res) {
  var promises = []
  var currency = bcSfFilterConfig.general.current_currency.toLowerCase();
  for (var i = 0; i < res.products.length; i++) {
    promises.push(new Promise(function(resolve, reject) {
	  getProduct(res.products[i].handle, function(i, product) {
        if (typeof product.availableVariants === 'object') {
          res.products[i].variants = res.products[i].variants.map(function(variant) {
				variant.price = product.availableVariants[variant.id];
                variant['price_' + currency] =  product.availableVariants[variant.id];
                return variant;
          });
        }
        res.products[i].compare_at_price_min = product.compare_at_price_min / 100
        res.products[i].price_min = product.price_min / 100
        res.products[i].price_max = product.price_max / 100
        res.products[i]['compare_at_price_min_' + currency] = product.compare_at_price_min / 100
        res.products[i]['price_min_' + currency] = product.price_min / 100
        res.products[i]['price_max_' + currency] = product.price_max / 100
        return resolve()
      }.bind(this, i))
    }))
  }
  Promise.all(promises).then(function() {
    var final_products = []
    var prod
    for (var i in res.products) {
        prod = res.products[i]
        if (typeof prod === 'object') {
            final_products.push(prod)
        }
    }
    res.products = final_products
    bc_BCSfSuggestionCallback(res);
  })
}
//
// End Search Grid Fix

//
function getProduct(handle, callback, jsonResult) {
  var url = bcSfFilterConfig.shop.url + '/products/' +  handle + '?view=multiple-currencies';
  if (!jsonResult) jsonResult = '';
  // Return a new promise.
  jQ.ajax({
    type: "GET",
    url: url,
    success: function (ajaxResult) {
      // Try to parse the json we get from collection endpot
      try {
        if(typeof Shopify.PaymentButton === "undefined" && /<\!--.*?-->/.test(ajaxResult)){
          ajaxResult = ajaxResult.replace(/<\!--.*?-->/g, "");
        }
        jsonResult = JSON.parse(ajaxResult);
      } catch (error) {
        console.log('Could not parse json from ' + url + ": " + error.message);
        return;
      }
      if (typeof callback == 'function') {
        callback(jsonResult.product);
      }
    }
  });
}